import { createSlice } from "@reduxjs/toolkit";

import { DispatcherRate } from "../../../../../services";
import { ReduxReducer } from "../../../../interface";
import { GlobalState } from "../../interface";

import { State } from "./interface";

const initialState: State = {
	subscription: {
		basic: [],
	},
};

const setSubscriptionBasicData: ReduxReducer<State, DispatcherRate.Model[]> = (
	state,
	action,
) => {
	state.subscription.basic = action.payload;
};

const reset: ReduxReducer<State, any> = (state) => {
	Object.keys(initialState).forEach((key) => {
		state[key] = initialState[key];
	});
};

const globalStateDispatcherRateData = createSlice({
	name: GlobalState.ConstantGlobalStateSlice.DISPATCHER_RATE_DATA,
	initialState,
	reducers: {
		reset,
		setSubscriptionBasicData,
	},
});

export const globalStateDispatcherRateDataAction =
	globalStateDispatcherRateData.actions;
export const globalStateDispatcherRateDataReducer =
	globalStateDispatcherRateData.reducer;
export type globalStateDispatcherRateDataState = State;

export default globalStateDispatcherRateData;
